import styled, { css } from "styled-components";
import { body01, heading01, heading02, heading03, heading04, heading05, heading06, } from "../styles";
import { ModalBody, ModalHeader } from "@carbon/react";
export const headingStyles = css `
	h1 {
		${heading06}
	}

	h2 {
		${heading05}
	}

	h3 {
		${heading04}
	}

	h4 {
		${heading03}
	}

	h5 {
		${heading02}
	}

	h6 {
		${heading01}
	}
`;
export const StyledModalHeader = styled(ModalHeader) `
	${headingStyles}
`;
export const StyledModalBody = styled(ModalBody) `
	padding-left: 17rem;

	${headingStyles}

	p {
		${body01}
	}
`;
